
import { elaineMediaArray } from './elaineMedia'
import { georgeReviewerProfile, jerryReviewerProfile, kramerReviewerProfile } from './elaineReviewers'
import { kramerBio, elaineBio, jerryBio, georgeBio } from './elaineBios'
import { elaineDatingProfileHinge, elaineDatingProfileBumble, elaineDatingProfileTinder } from './elaineDatingProfiles'

export const elaineUser = {
  _id: 'elaineUserId',
  email: 'elaine@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...georgeReviewerProfile },
    { ...jerryReviewerProfile },
    { ...kramerReviewerProfile }
  ],
  media: [ ...elaineMediaArray ],
  bio: { ...elaineBio },
  datingProfiles: [
    { ...elaineDatingProfileHinge },
    { ...elaineDatingProfileBumble },
    { ...elaineDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const georgeUser = {
  _id: 'georgeUserId',
  email: 'george@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...georgeBio },
  datingProfiles: [],
  reviewerProfile: { ...georgeReviewerProfile },
}

export const jerryUser = {
  _id: 'jerryUserId',
  email: 'jerry@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...jerryBio },
  datingProfiles: [],
  reviewerProfile: { ...jerryReviewerProfile },
}

export const kramerUser = {
  _id: 'kramerUserId',
  email: 'kramer@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...kramerBio },
  datingProfiles: [],
  reviewerProfile: { ...kramerReviewerProfile },
}
